var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOvertime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36 1.009A7 7 0 0115 8l-.009.36A7 7 0 018 15l-.36-.009a7.001 7.001 0 01-6.631-6.63L1 8a7 7 0 017-7l.36.008zM8 2.2a5.8 5.8 0 100 11.6A5.8 5.8 0 008 2.2zm0 1.7a.6.6 0 01.6.6v2.9H10a.6.6 0 110 1.2H8a.6.6 0 01-.6-.6V4.5a.6.6 0 01.6-.6z"
  })));
}
export default SvgIconOvertime;